import React, { Component, ReactNode } from 'react';
import { Button } from 'antd';
import cx from 'classnames';

import { Features, isFeatureEnabled } from '../../featureToggles/features';
import { FeatureToggle, Off, On } from '../../featureToggles';

import { capitalizeFirstLetter } from './utils/string';

import styles from './activeInactiveToggleStyles.module.scss';

export enum ActiveInactiveFilterState {
  All = 'ALL',
  Active = 'ACTIVE',
  Lapsed = 'LAPSED', // to use with PlgExternal feature
  Inactive = 'INACTIVE',
}

interface Props {
  state: ActiveInactiveFilterState;
  onChange: (newState: ActiveInactiveFilterState) => void;
  // use for Features.PlgExternal
  filters: ActiveInactiveFilterState[];
  // end of use for Features.PlgExternal
}

export class ActiveInactiveToggle extends Component<Props> {

  private renderButton(state: ActiveInactiveFilterState, text: string):ReactNode {
    const activeState = this.props.state;
    return (
      <Button
        key={text}
        onClick={this.props.onChange.bind(this, state)}
        type={state === activeState ? 'primary' : undefined}
        className={styles.blackText}
      >{text}</Button>
    );
  }

  render():ReactNode {
    const { filters } = this.props;
    return (
      <span className={cx(styles.container, { [styles[Features.Uirefresh]]: isFeatureEnabled(Features.Uirefresh) })}>
        <FeatureToggle feature={Features.PlgExternal}>
          <Off>
            {this.renderButton(ActiveInactiveFilterState.All, 'All')}
            {this.renderButton(ActiveInactiveFilterState.Active, 'Active')}
            {this.renderButton(ActiveInactiveFilterState.Inactive, 'Inactive')}
          </Off>
          <On>
            {
              filters.map((filter) => this.renderButton(filter, capitalizeFirstLetter(filter)))
            }
          </On>
        </FeatureToggle>
      </span>
    );
  }
}
